module.exports = __webpack_public_path__ + "img/cloud-1.5d6b81fb.svg";